import {ref} from "vue";

// Event Emitter für Kommunikation mit Komponenten
class EventEmitter {
    constructor() {
        this.events = {};
    }
    
    on(event, callback) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        if (typeof callback === 'function') {
            this.events[event].push(callback);
        } else {
            console.warn('Event callback must be a function');
        }
    }
    
    emit(event, data) {
        if (this.events[event]) {
            this.events[event].forEach(callback => {
                if (typeof callback === 'function') {
                    callback(data);
                } else {
                    console.warn('Callback is not a function:', callback);
                }
            });
        }
    }
    
    off(event, callback) {
        if (this.events[event]) {
            this.events[event] = this.events[event].filter(cb => cb !== callback);
        }
    }
}

const wsEventEmitter = new EventEmitter();

export default function useWebsocket() {
    let socket = null

    const socketConnected = ref(false)

    function startConnection(callback){
        try{
        socket =
            process.env.NODE_ENV === "production"
            ? new WebSocket("wss://teamup-ws.jobjournal.io")
            : new WebSocket("ws://localhost:3003")

        socket.onopen = () => {
            socketConnected.value = true;
            if (typeof callback === 'function') {
                callback();
            }
        }
        } catch(e) {
            console.error(e)
        }
        socket.onmessage = onSocketMessage
        socket.onclose = onSocketClose
        socket.onerror = (error) => {
            console.error('WebSocket error:', error);
            wsEventEmitter.emit('ws_error', error);
        }
    }

    function closeSession(){
        socket.close()
    }

    function joinSession(user_id){
        socket.send(JSON.stringify({msg: "connect", user_id: user_id}))
    }

    function sendWSMessage(receiver_id){
        if(socket){
            socket.send(JSON.stringify({msg: "send_message", receiver_id: receiver_id}))
        } else {
            console.info("no socket connection active!")
        }
    }

    function startedTyping(receiver_id) {
      if (socket) {
        socket.send(
          JSON.stringify({ msg: "started_typing", receiver_id: receiver_id })
        );
      } else {
        console.info("no socket connection active!");
      }
    }

    function stoppedTyping(receiver_id) {
      if (socket) {
        socket.send(
          JSON.stringify({ msg: "stopped_typing", receiver_id: receiver_id })
        );
      } else {
        console.info("no socket connection active!");
      }
    }

    function onSocketMessage(evt){
        let data = null
        try{
            data = JSON.parse(evt.data)
        } catch {
            data = {}
        }

        if(data.info && data.info === "new_msg"){
            // Event an Komponenten senden statt window.location.reload()
            wsEventEmitter.emit('new_message', data);
        } else if (data.info && data.info === "partner_started_typing"){
            console.log("partner started typing")
            wsEventEmitter.emit('partner_typing', { status: 'started', sender_id: data.sender_id });
        } else if (data.info && data.info === "partner_stopped_typing"){
            wsEventEmitter.emit('partner_typing', { status: 'stopped', sender_id: data.sender_id });
        }
        
        // Allgemeines Event für alle WebSocket-Nachrichten
        wsEventEmitter.emit('ws_message', data);
    }

    function onSocketClose(){
        socketConnected.value = false
    }

    return {
        startConnection,
        joinSession,
        sendWSMessage,
        startedTyping,
        stoppedTyping,
        closeSession,
        // Event-Funktionen exportieren
        on: wsEventEmitter.on.bind(wsEventEmitter),
        off: wsEventEmitter.off.bind(wsEventEmitter),
        emit: wsEventEmitter.emit.bind(wsEventEmitter)
    }
}
